import HeaderButtons from "./HeaderButtons";
import HeaderInfos from "./HeaderInfos";
import HeaderMenu from "./HeaderMenu";
import HeaderRoot from "./HeaderRoot";

const Header = {
  Root: HeaderRoot,
  Buttons: HeaderButtons,
  Infos: HeaderInfos,
  Menu: HeaderMenu,
};

export default Header;
